//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { CalendarIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Collapse,
  Divider,
  Flex,
  Stack,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { format } from "date-fns";
import * as React from "react";
import { addDays, getLessonTime, getWeekDay } from "../utils/functions";
import Icon from "../components/ui-elements/Icon";

type Props = {
  weeklySchedule: any;
  booking: any;
  onSubmit: (value: any) => void;
  isSubmitting: boolean;
};

function getNextDayOfWeek(date = new Date(), dayOfWeek) {
  let resultDate = new Date(date.getTime());
  resultDate.setDate(date.getDate() + ((7 + dayOfWeek - date.getDay()) % 7));
  return resultDate.toISOString().split("T")[0];
}

const generateSessions = (
  booking: any = {},
  hoursBooked: number,
  weeklySchedule: any = {},
  startDate: any,
) => {
  const { billingInfo, students: studentsArray } = booking;
  const bookingPrice =
    (billingInfo.tutorEarnings / billingInfo.earningPercentage) * 100;
  const perHourPrice = bookingPrice / hoursBooked;
  const students = studentsArray.length;
  const weekDays = weeklySchedule.weekDays;

  const getNextSession = (currentDate: any) => {
    const dayIndex = {
      Sunday: 0,
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6,
    };
    const dayArrayIndex = Object.keys(weekDays)
      .map((day) => dayIndex[day])
      .sort((a, b) => a - b);
    const currentDay = dayIndex[getWeekDay(currentDate)];

    if (dayArrayIndex.length === 1) {
      let nextDate = addDays(currentDate, 7);
      return nextDate.toISOString().split("T")[0];
    }

    const currentDayIndex = dayArrayIndex.findIndex((e) => currentDay === e);
    const nextDayIndex =
      currentDayIndex + 1 < dayArrayIndex.length ? currentDayIndex + 1 : 0;
    const nextDay = dayArrayIndex[nextDayIndex];
    return getNextDayOfWeek(new Date(currentDate), nextDay);
  };

  const getSession = (date, hoursLeft) => {
    const sessionDay = getWeekDay(date);
    const schedule = weekDays[sessionDay];
    const startTime = schedule.startTime;
    const dayHours = parseFloat(schedule.hours);
    const hours = dayHours > hoursLeft ? hoursLeft : dayHours;

    return {
      startDate: date,
      startTime,
      price: hours * perHourPrice,
      students,
      hours,
    };
  };

  let sessions = [];
  let shouldContinue = true;
  let hoursLeft = hoursBooked;
  let sessionDate = startDate;

  while (shouldContinue && hoursLeft > 0) {
    let session = getSession(sessionDate, hoursLeft);
    sessions.push(session);

    if (hoursLeft > 0) {
      hoursLeft = hoursLeft - session.hours;
      sessionDate = getNextSession(sessionDate);
    } else shouldContinue = false;
  }

  return sessions;
};

const ScheduleLessons = ({
  weeklySchedule,
  booking,
  isSubmitting,
  onSubmit,
  ...rest
}: Props) => {
  const startDate = weeklySchedule.startDate;
  const hoursBooked = weeklySchedule.hoursBooked;
  const weekDays = weeklySchedule.weekDays;
  const sessions = generateSessions(
    booking,
    hoursBooked,
    weeklySchedule,
    startDate,
  );
  const first = sessions[0];
  const last = sessions[sessions.length - 1];

  const [comment, setComment] = React.useState("");
  const [show, setShow] = React.useState(false);
  const handleToggle = () => setShow(!show);

  const handleClick = () => {
    onSubmit({ comment, sessions });
  };

  return (
    <Stack spacing={3} width="100%" {...rest}>
      <Flex align="center" justify="space-between">
        <Box>
          <Text fontSize="sm" opacity={0.8}>
            From
          </Text>
          <Text fontSize="lg">
            {getWeekDay(first.startDate, "shortDay")},{" "}
            {format(first.startDate, "MMM Do")}
          </Text>
        </Box>
        <Icon name="chevron-right" color="gray.500" size={5} mx={5} />
        <Box>
          <Text fontSize="sm" opacity={0.8}>
            To
          </Text>
          <Text fontSize="lg">
            {getWeekDay(last.startDate, "shortDay")},{" "}
            {format(last.startDate, "MMM Do")}
          </Text>
        </Box>
      </Flex>

      <Divider />

      <Stack my={2} spacing={3}>
        {Object.entries(weekDays).map(([weekDay, schedule]: any) => (
          <Flex key={weekDay} align="center" justify="space-between">
            <Text>{weekDay}s</Text>
            <Text textTransform="lowercase">
              {getLessonTime({
                lessonTime: schedule.startTime,
                lessonHours: schedule.hours,
              })}
            </Text>
          </Flex>
        ))}
      </Stack>

      <Divider />

      <Stack spacing={3}>
        <Flex justify="space-between">
          <Box>
            <Text>Total lessons</Text>
            <Text fontSize="sm" color="gray.500">
              Client may book more lessons
            </Text>
          </Box>
          <Text>{sessions.length}</Text>
        </Flex>

        <Flex align="center" justify="space-between">
          <Text>Total hours</Text>
          <Text>{hoursBooked}</Text>
        </Flex>
      </Stack>

      <Stack
        my={2}
        px={5}
        py={4}
        bg="orange.50"
        fontSize="sm"
        borderRadius="fbRadius"
      >
        <Text fontWeight="medium">Any change to this booking?</Text>
        <Text>
          If the client wants to increase or reduce the number of lessons or
          hours, please leave a comment to inform us.
        </Text>

        <Button
          mt={2}
          alignSelf="flex-start"
          onClick={handleToggle}
          colorScheme="blue"
          size="sm"
          variant="link"
        >
          Leave a comment
        </Button>

        <Collapse in={show}>
          <Textarea
            resize="none"
            placeholder="If the schedule has changed, please tell us here."
            onChange={(e) => setComment(e.target.value)}
          />
        </Collapse>
      </Stack>

      <Button
        mt={5}
        isFullWidth
        iconSpacing={3}
        colorScheme="blue"
        size="lg"
        leftIcon={<CalendarIcon />}
        isLoading={isSubmitting}
        loadingText="Booking"
        onClick={handleClick}
      >
        Book and get started
      </Button>
    </Stack>
  );
};

export default ScheduleLessons;
